<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="smvisible"
    append-to-body
    class="dialogClass"
    title="选择商品"
    width="1000px"
  >
    <div>
      <el-button type="primary" @click="look()" style="margin-bottom: 20px"
        >确认选择</el-button
      >
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column
          align="center"
          label="商品封面"
          prop="storeGoodsCover"
          width="100"
        >
          <template slot-scope="scope">
            <el-image
              :src="scope.row.cover"
              fit="scale-down"
              style="width: 70px; height: 70px"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="商品名"
          prop="commodityName"
          min-width="260"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="商品规格"
          prop="commoditSpecifications"
          width="200"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="库存"
          prop="quantityStock"
          width="200"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="searchForm.pageNo"
        :page-size="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SingProduct",
  components: {},
  data() {
    return {
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        entrepotId: "",
      },
      smvisible: false,
      tableData: [],
      multipleSelection: [38],
      total: 0,
      copy: [],
    };
  },
  created() {},
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    init(row) {
      this.searchForm = {
        entrepotId: row.type == 1 ? "" : row.id,
        pageNo: 1,
        pageSize: 10,
      };
      this.getGoods();
      this.smvisible = true;
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getGoods();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getGoods();
    },
    lookinfo() {
      this.$emit("goodsbark", this.multipleSelection);
      this.smvisible = false;
    },
    getGoods() {
      this.$axios
        .get(
          "/admin/entrepotCommodity/getDispatchCommodityList?pageNo=" +
            this.searchForm.pageNo +
            "&pageSize=" +
            this.searchForm.pageSize +
            "&entrepotId=" +
            this.searchForm.entrepotId,
          {},
        )
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 30px;
  font-size: 10px;
  margin-right: 10px;
  margin-top: 5px;
}

.titcon {
  width: 150px;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.issline {
  height: 1px;
  background: #e1e1e1;
  width: 100%;
}

.stimg {
  width: 50px;
  height: 50px;
  border-radius: 6rpx;
  display: inline-block;
  margin-right: 10rpx;
}

.mb8 {
  margin-bottom: 10px;
}
</style>
